import { useState, useEffect } from 'react'
import styles from "../../../pages/Home/ClientConfig/ClientConfig.module.css"
import HoverButton from '../../../components/Miscellaneous/HoverButton'
import * as eventManagementService from '../../../services/eventManagementService'

const SwoogoConfig = ({
    formData,
    swoogoClientConfig,
    setSwoogoClientConfig,
}) => {

    const isFormValid = () => {
        return formData.ClientName
            && formData.EventRegistrationSystem
            && formData.Industry
            && formData.Categories.length > 0
            && swoogoClientConfig.Key
            && swoogoClientConfig.Secret
            && swoogoClientConfig.Url
            ? true
            : false
    }
    const isTestFormValid = () => {
        return swoogoClientConfig.Key
            && swoogoClientConfig.Secret
            && swoogoClientConfig.Url
            ? true
            : false
    }

    const handleChange = e => {
        setSwoogoClientConfig({
            ...swoogoClientConfig,
            [e.target.name]: e.target.value,
        })
        //console.log(swoogoClientConfig)
    }
    const [error, setError] = useState(null)
    const errorDiv = (error)
        ?
        <ul>
            {Object.entries(error).length > 0 && Object.entries(error) &&
                Object.entries(error).map(([key, value]) => {
                   // console.log("error: " + error)
                    return <div className={value[0] === 'Test Failure' ? styles.errorMSG : styles.successMSG} key={key} >{value}</div>;
                })}
        </ul>
        : '';
    const handleTestConnection = async e => {
        e.preventDefault()
        var holder = { swoogoClientConfig };
        setError(null)
        try {
            await eventManagementService.testSetup(holder)
        } catch (err) {
           // console.log(err.message)
            setError(err.internalError);
        }
    }

    return (
        <>
            <div className={styles.inputContainer}>
                <label htmlFor="Key" className={styles.label}>
                    Client Key
                    <HoverButton
                        title={"Client Key client credential"}
                        messageWidth={200}
                    />
                    :
                </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={swoogoClientConfig.Key}
                    name="Key"
                    onChange={handleChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <label htmlFor="Secret" className={styles.label}>
                    Client Secret
                    <HoverButton
                        title={"Client Secret client credential"}
                        messageWidth={200}
                    />
                    :
                </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={swoogoClientConfig.Secret}
                    name="Secret"
                    onChange={handleChange}
                />
            </div>
            <div className={styles.inputContainer}>
                <label htmlFor="Url" className={styles.label}>
                    Url
                    <HoverButton
                        title={"Client Url"}
                        messageWidth={200}
                    />
                    :
                </label>
                <input
                    type="text"
                    autoComplete="off"
                    value={swoogoClientConfig.Url}
                    name="Url"
                    onChange={handleChange}
                />
            </div>
            {errorDiv}
            <div className={styles.inputContainer}>
                <button disabled={!isFormValid()} className={styles.button}>
                    Submit
                </button>
                <button onClick={handleTestConnection} disabled={!isTestFormValid()} className={styles.buttonRight}>
                    Test Connection
                </button>
            </div>
        </>
    );
}

export default SwoogoConfig;